import { render } from "./OriginalPaper.vue?vue&type=template&id=63c2f45a&ts=true"
import script from "./OriginalPaper.vue?vue&type=script&lang=ts"
export * from "./OriginalPaper.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/shunta/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__